export const API_URL = "https://checkin-api-u7l2alkhqa-ey.a.run.app/";
//export const API_URL = "http://localhost:8080/";
